import { Component, defineComponent, onMounted } from 'vue';

import Sort from './Sort.class';
import SortContainer from './sort-container/SortContainer.vue';

export default defineComponent({
	components: {
		SortContainer: SortContainer as Component,
	},

	setup: () => {
		const component = new Sort();

		onMounted(component.mounted.bind(component));

		return {
			sortButton: component.sortButton,
			toggle: component.toggle.bind(component),
		};
	},
});
